import { render } from "./FormCambiarPassUsers.vue?vue&type=template&id=84ae3bd6"
import script from "./FormCambiarPassUsers.vue?vue&type=script&lang=js"
export * from "./FormCambiarPassUsers.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__